import { Component } from '@angular/core';
import { ParameterService } from '../../services/parameter/parameter.service';
import { CurrencyService } from './services/currency.service';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'core-app-currency-dialog',
  templateUrl: './currency.component.html',
  styleUrl: './currency.component.scss',
  providers: [DecimalPipe],
})
export class CurrencyComponent  {
  visible: boolean = false;

  currencies: any[] = [];
  selectedDate: Date = new Date();
  latestUpdatedDate: Date | null = new Date();
  maxDate = new Date();

  fromCurrency: any = null;
  amount: number = 1000;
  formattedAmount: string = '1000';
  toCurrency: any = null;
  selectedToCurrency: any = null;
  calculatedAmount: any = 0;

  first = 0;
  rows = 10;
  totalRecords: number = 0;
  items: any[] = [];

  selectedValue: any = null; // tabloda seçili olan row item'ı için
  isLeftTL: boolean = true;

  getCurrencies() {
    this.parameterService
      .getParameterValues('data-group', 'currencies')
      .subscribe((res) => {
        this.currencies = res?.datas?.values
          ?.filter((r: any) => r.valueObject.name.value !== 'TRY')
          ?.map((data: any) => {
            if (data.valueObject.name.value === 'USD') {
              this.selectedToCurrency = {
                label: data.valueObject.name.value,
                flag: data.valueObject.flag.value,
                value: data.id,
              };
              this.toCurrency = data?.id;
              this.amount = 1000;
            }

            return {
              label:
                data.valueObject.flag.value + ' ' + data.valueObject.name.value,
              value: data.id,
            };
          });
      });
    this.fromCurrency = '🇹🇷 TRY';
  }

  async initilizeSelectedDate() {
    this.selectedDate = new Date();

    // Türkiye saatine göre güncel tarih
    const currentDate = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'Europe/Istanbul' })
    );

    // Türkiye saatine göre 15:30 (cutoff time)
    const cutoffTime = new Date(currentDate);
    cutoffTime.setHours(15, 30, 0, 0);

  
    this.selectedDate.setHours(0, 0, 0);
  }

  constructor(
    private readonly  parameterService: ParameterService,
    private readonly service: CurrencyService,
    private readonly messageService: AppMessageService,
    private readonly translateService: TranslateService,
    private readonly decimalPipe: DecimalPipe
  ) {}


  onDateSelected(event: any) {
    if (this.selectedDate) {
      this.getTodayCurrencies(this.selectedDate);
    }
  }

  getTodayCurrencies(date: Date = new Date()) {
    this.service.getCurrentDayCurrencies(date).subscribe((res: any) => {
      this.items = res?.data;
      this.totalRecords = res?.data?.length;
      this.latestUpdatedDate = res?.latestCreatedAt;
      this.calculateInitialResult();
    });
  }

  calculateInitialResult() {

    let numericValue = Number.parseFloat('1000'.replaceAll(/[^0-9.]/g, '')) || 0;
    this.amount = numericValue;
    this.formattedAmount =
      this.decimalPipe.transform(numericValue, '1.2-2') || '';
    const foundedIndex = this.items?.findIndex((i: any) => i.code === 'USD');
    if (foundedIndex !== -1) {
      this.selectedValue = this.items[foundedIndex].banknoteSelling;
      if(this.isLeftTL){
        this.calculatedAmount =Number(numericValue)/ Number(this.selectedValue);
      }else{
        this.calculatedAmount =Number(numericValue)* Number(this.selectedValue);
      }

    }
  }

  closeDialog() {
    this.visible = false;
    this.resetValues();
  }

  openDialog() {
    this.visible = true;
    this.initilizeSelectedDate();
    this.getTodayCurrencies(this.selectedDate);
    this.getCurrencies();
    this.calculateInitialResult();
  }

  onToCurrencySelected(event: any) {
    const selected = this.currencies?.findIndex((c) => c.value === event);
    if (selected !== -1) {
      this.selectedToCurrency = this.currencies[selected];
      const code=this.selectedToCurrency?.label?.split(' ')[1]
      const foundedIndex = this.items?.findIndex((i: any) => i.code === code);
      if (foundedIndex !== -1) {
        this.selectedValue = this.items[foundedIndex].banknoteSelling;
      }
    }
  }

  calculateAmount(): void {
    if (!this.validateInputs()) return;
    this.computeAmount();
  }

  private validateInputs(): boolean {
    if (!this.selectedToCurrency) {
      this.messageService.warningToast(
        this.translateService.instant('common.warning'),
        this.translateService.instant('currency.convert-currency-missing')
      );
      return false;
    }

    if (!this.selectedValue) {
      this.messageService.warningToast(
        this.translateService.instant('common.warning'),
        this.translateService.instant('currency.convert-selected-value-missing')
      );
      return false;
    }

    return true;
  }

  private computeAmount(): void {
    const amountValue = Number.parseFloat(String(this.amount).replace(',', '.'));
    const selectedValue = Number(this.selectedValue);

    if (Number.isNaN(amountValue) || Number.isNaN(selectedValue)) {
      console.error('Invalid input detected', { amountValue, selectedValue });
      return;
    }

    this.calculatedAmount = this.isLeftTL
      ? amountValue / selectedValue
      : amountValue * selectedValue;
  }


  selectValue(value: any) {
    this.selectedValue = value;
  }

  resetValues() {
    this.selectedValue = null;
    this.currencies = [];
    this.items = [];
    this.totalRecords = 0;
    this.calculatedAmount = 0;
    this.amount = 0;
  }

  swapCurrencies() {
    this.isLeftTL = !this.isLeftTL; // TL'nin konumunu değiştiriyoruz
  this.fromCurrency = '🇹🇷 TRY';
    

    // Miktarları değiştiriyoruz
    // [this.amount, this.calculatedAmount] = [this.calculatedAmount, this.amount];

    this.calculateAmount();
  }

  showRefreshButton(): boolean {
    if (this?.items?.length === 0) {
      const currentDate = new Date();
      const currentHour = currentDate.getHours();
      const currentMinute = currentDate.getMinutes();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
      let searchDate = new Date(this.selectedDate);

      const searchDay = searchDate.getDate();
      const searchMonth = searchDate.getMonth() + 1;
      const searchYear = searchDate.getFullYear();
      if (
        currentDay === searchDay &&
        currentMonth === searchMonth &&
        currentYear === searchYear
      ) {
        if (currentHour >= 15 && currentMinute >= 30) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  onFetchCurrencies() {

    if (this.showRefreshButton()) {
      this.service.saveCurrenciesTodDb().subscribe((res) => {
        if (res?.success) {
          this.items = res?.data;
          this.totalRecords = res?.data?.length;
          if (res?.data?.length > 0) {
            this.latestUpdatedDate = res?.latestCreatedAt;
            this.calculateInitialResult();
          }
        } else {
          this.messageService.errorToast(
            this.translateService.instant('common.error'),
            this.translateService.instant(res?.message)
          );
        }
      });
    }
  }

  // onAmountEntered(value: string): void {
  //   // let numericValue = parseFloat(value.replace(/[^0-9.]/g, '')) || 0;
  //   // this.amount = numericValue;

  onAmountEntered(value: string) {
    const numericValue = Number(value.replaceAll(/[^0-9.-]+/g, ''));
    this.amount = numericValue;
    this.formattedAmount = value; // keep the raw input while typing
  }

  formatAmount() {
    if (this.amount != null) {
      this.formattedAmount = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.amount);
    }
  }

  removeFormatting() {
    // Allow user to edit raw number again
    if (this.amount != null) {
      this.formattedAmount = this.amount.toString();
    }
  }

  formattedCalculatedAmount(){
    return this.selectedToCurrency?.label?.split(' ')[1] || 'USD';
  }
}
